import { render, staticRenderFns } from "./animation-effect.vue?vue&type=template&id=33163634&"
import script from "./animation-effect.vue?vue&type=script&lang=js&"
export * from "./animation-effect.vue?vue&type=script&lang=js&"
import style0 from "./animation-effect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports